/**
 * Synchronizes homepage hero slider heights.
 */
document.addEventListener('DOMContentLoaded', function() {
  function updateHeroSliderHeights() {
    if (window.innerWidth > 1024) {
      const slides = document.querySelectorAll('.hero-slider .slide');
      let maxTextHeight = 0;
      
      // Loop through the slides to find the maximum height of slide text blocks
      slides.forEach(function(slide) {
        const textBlock = slide.querySelector('.text-content-container');
     
        if (textBlock) {
          const currentHeight = textBlock.offsetHeight;
          if (currentHeight > maxTextHeight) {
            maxTextHeight = currentHeight;
          }
        }
      });
         //console.log(maxTextHeight);
      
      // Set the universal CSS variable on the document's root
      document.documentElement.style.setProperty('--hero-slider-height', (maxTextHeight + 40) + 'px');
    } else {
      // On smaller viewports, remove the CSS variable
      document.documentElement.style.removeProperty('--hero-slider-height');
    }
  }
  
  updateHeroSliderHeights();
  window.addEventListener('resize', updateHeroSliderHeights);
});